// Founding Cohort roster — one dark table of all participants.

const OB_CLS = {
  complete: "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]",
  in_progress: "border-gold/60 bg-gold/10 text-goldlight",
  pending: "border-silver/40 text-silver/60",
};

export const RosterTable = ({ rows, loading, onSelect }) => (
  <div className="mt-4 overflow-x-auto border border-gold/25 bg-charcoal">
    <table className="w-full min-w-[860px]" data-testid="roster-table">
      <thead className="border-b border-gold/25 bg-onyx">
        <tr className="text-left font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-gold">
          {["Member #", "Name", "Lane", "Invitation", "Onboarding", "Missions", "Public", "Orientation"].map((h) => (
            <th key={h} className="p-3">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.application_id} onClick={() => onSelect(r)} data-testid={"roster-row-" + r.application_id}
            className="cursor-pointer border-b border-silver/10 font-body text-sm text-silver transition-colors hover:bg-gold/5">
            <td className="p-3 font-mono text-xs font-bold text-gold" data-testid={"roster-member-" + r.application_id}>{r.member_number || "—"}</td>
            <td className="p-3 font-bold text-cream">
              {r.name || "—"}
              <br />
              <span className="font-mono text-[10px] font-normal text-silver/50">{r.email}</span>
            </td>
            <td className="p-3">{r.lane || <span className="text-silver/40">Unassigned</span>}</td>
            <td className="p-3">
              <span className={"border px-2 py-0.5 font-mono text-[9px] font-bold uppercase " + (r.place_accepted ? "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]" : r.invitation_opened ? "border-gold/60 bg-gold/10 text-goldlight" : "border-silver/40 text-silver/60")}>
                {r.place_accepted ? "Accepted" : r.invitation_opened ? "Opened" : "Sent"}
              </span>
            </td>
            <td className="p-3">
              <span className={"border px-2 py-0.5 font-mono text-[9px] font-bold uppercase " + (OB_CLS[r.onboarding_status] || OB_CLS.pending)}>
                {(r.onboarding_status || "pending").replace(/_/g, " ")}
              </span>
              <span className="ml-2 font-mono text-[10px] text-silver/50">{r.sections_done}/{r.sections_total}</span>
              <div className="mt-1 h-1 w-24 bg-onyx">
                <div className="h-1 bg-gradient-to-r from-gold to-goldlight" style={{ width: `${(r.sections_done / r.sections_total) * 100}%` }} />
              </div>
            </td>
            <td className="p-3 font-mono text-xs" data-testid={"roster-missions-" + r.application_id}>
              {(r.mission_assignments || []).length ? (r.mission_assignments || []).map((m) => (
                <span key={m} className="mr-1 border border-gold/40 bg-gold/10 px-1.5 py-0.5 font-bold text-goldlight">{m}</span>
              )) : <span className="text-silver/40">—</span>}
            </td>
            <td className="p-3" data-testid={"roster-public-" + r.application_id}>
              <span className={"border px-2 py-0.5 font-mono text-[9px] font-bold uppercase " + (r.profile_public_status === "public" ? "border-[#3ad07a]/60 bg-[#3ad07a]/10 text-[#3ad07a]" : "border-silver/40 text-silver/60")}>
                {r.profile_public_status === "public" ? "Public" : "Hidden"}
              </span>
            </td>
            <td className="p-3 font-mono text-xs">{r.orientation_date || <span className="text-silver/40">TBD</span>}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {!loading && rows.length === 0 && (
      <p className="p-10 text-center font-head text-lg font-bold uppercase text-silver/40" data-testid="roster-empty">No founding members yet — accept an applicant to start the roster.</p>
    )}
    {loading && <p className="p-10 text-center font-head text-sm font-bold uppercase text-silver/40">Loading...</p>}
  </div>
);
